
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, EventType, LogLevel } from '@azure/msal-browser';
import { useGlobalInformationStore } from "@stores/global_informationStore";

export function createMSALInstance(client: any) {
  
  let msalInstance = new PublicClientApplication({
    auth: {
      clientId: client?.clientId || "", // This is the ONLY mandatory field that you need to supply.
      authority: client?.authority || "", // Defaults to "https://login.microsoftonline.com/common"
      redirectUri: "/", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
      postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
      navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
      cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
            default:
              return;
          }
        },
      },
    },
  });
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  msalInstance.addEventCallback((event: any) => {
    if ((event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.SSO_SILENT_SUCCESS) && event.payload?.account) {
      msalInstance.setActiveAccount(event.payload?.account);
    }
  });
  return msalInstance;
}
